var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateDraft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.768 12.83h3.765v-1.54h-3.765zm0 5.741h3.765v-1.539h-3.765zM5.467 6.969h3.765v-1.54H5.466zm8.739 7.29h4.892A.894.894 0 0 0 20 13.38v-2.639a.894.894 0 0 0-.902-.879h-4.892a.894.894 0 0 0-.902.88v.687H8.081V8.398h1.712a.893.893 0 0 0 .902-.88V4.88a.893.893 0 0 0-.9-.88H4.902A.893.893 0 0 0 4 4.88v2.638c0 .484.406.88.902.88h1.713v9.956h1.09v.001h5.598v.765c0 .485.406.88.902.88h4.892a.893.893 0 0 0 .902-.88v-2.637a.893.893 0 0 0-.902-.88h-4.892a.893.893 0 0 0-.902.88v.443H8.082v-4.068h5.22v.522c0 .484.407.88.903.88Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateDraft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-draft.9047cfd6.svg";